import React from 'react';
import PropTypes from 'prop-types';

const CalendarViewSelect = ({ options, onView, onSelect, ...props }) => (
  <div className='calendar__views flex-column text--left' {...props}>
    {options.map(option => (
      <p
        onClick={() => {
          onView(option.name);
          onSelect(false);
        }}
        className='calendar__views__option pt-1x pb-1x pl-3x pr-3x'
        key={option.name}
        role='presentation'
      >
        {option.label}
      </p>
    ))}
  </div>
);

CalendarViewSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onView: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default CalendarViewSelect;
